import {ProductGrid} from '../features/product-grid';
import {GridSlider} from '../features/grid-slider';
import {register} from '../vendor/theme-scripts/theme-sections';

const selectors = {
  product: '[data-product-block]',
  relatedProducts: '[data-related-products]',
};

const attributes = {
  sectionId: 'data-section-id',
  productId: 'data-product-id',
  limit: 'data-limit',
};

const sections = {};

class RelatedProducts {
  constructor(container) {
    this.container = container;
    this.relatedProducts = this.container.querySelector(selectors.relatedProducts);

    this.init();
  }

  init() {
    const sectionId = this.container.getAttribute(attributes.sectionId);
    const productId = this.container.getAttribute(attributes.productId);
    const limit = this.container.getAttribute(attributes.limit);
    const requestUrl = `${theme.routes.product_recommendations_url}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;

    fetch(requestUrl)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        const createdElement = document.createElement('div');
        createdElement.innerHTML = data;
        const inner = createdElement.querySelector(selectors.relatedProducts);

        if (inner.querySelectorAll(selectors.product).length) {
          this.relatedProducts.innerHTML = inner.innerHTML;

          this.productGrid = new ProductGrid(this.container);
          this.gridSlider = new GridSlider(this.container);
        }
      });
  }

  /**
   * Event callback for Theme Editor `section:deselect` event
   */
  onDeselect() {
    if (this.productGrid) {
      this.productGrid.onDeselect();
    }
  }

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
    if (this.productGrid) {
      this.productGrid.onUnload();
    }

    if (this.gridSlider) {
      this.gridSlider.onUnload();
    }
  }
}

const RelatedProductsSection = {
  onLoad() {
    sections[this.id] = new RelatedProducts(this.container);
  },
  onDeselect() {
    sections[this.id].onDeselect();
  },
  onUnload() {
    sections[this.id].onUnload();
  },
};

register('related-products', RelatedProductsSection);
